import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table, Modal } from "react-bootstrap";
import {
  TokenTransactionActions,
  updateTokenTransactionAsync,
} from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";

const TokenTransactionTable = ({ onEditClick }) => {
  const { isLoading, transactionList, skip, limit } = useSelector(
    (state) => state.tokenTransaction,
    shallowEqual
  );

  const [ApproveModal, setApproveModal] = useState(false);
  const [CreditApproveModal, setCreditApproveModal] = useState(false);
  const deleteClose = () => {
    setApproveModal(false);
    setShowTextBox(false);
  };
  const creditModalClose = () => {
    setCreditApproveModal(false);
    setShowCreditReasonBox(false);
  };
  const deleteShow = () => setApproveModal(true);
  const creditModalShow = () => setCreditApproveModal(true);
  const [showTextBox, setShowTextBox] = useState(false);
  const [showCreditReasonBox, setShowCreditReasonBox] = useState(false);
  const [reasonDecline, setReasonDecline] = useState("");
  const [creditDeclineReason, setCreditDeclineReason] = useState("");
  const dispatch = useDispatch();
  const [selectedTokenName, setselectedTokenName] = useState({});
  //on page change
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(TokenTransactionActions.setVirtualTokenBatchNumber(count));
  };
  //show approv model and change approv status
  const onApprovedClick = (transactionData) => {
    setselectedTokenName(transactionData);
    deleteShow();
  };

  // show credit approv model and change approv status
  const onCreditApprovedClick = (transactionData) => {
    setselectedTokenName(transactionData);
    creditModalShow();
  };

  //change status of debit transaction for user
  const handleToggle = () => {
    const obj = {
      withdrawal_approved: true,
      user_id: selectedTokenName.user_id,
      amount: selectedTokenName.amount,
      transactionId: selectedTokenName.transactionId,
    };
    dispatch(updateTokenTransactionAsync(obj, selectedTokenName._id));
    setselectedTokenName({});
    deleteClose();
  };

  const handleDiclineToggle = () => {
    setShowTextBox(true);
  };

  const handleDiclineSubmit = () => {
    const obj = {
      is_decline: true,
      decline_reason: reasonDecline,
      user_id: selectedTokenName.user_id,
      amount: selectedTokenName.amount,
      transactionId: selectedTokenName.transactionId,
    };
    dispatch(updateTokenTransactionAsync(obj, selectedTokenName._id));
    setselectedTokenName({});
    deleteClose();
  };

  // CREDIT: approve payment (mark as SUCCESS)
  const handleCreditApprove = () => {
    const obj = {
      status: "SUCCESS",
      user_id: selectedTokenName.user_id,
      amount: selectedTokenName.amount,
      transaction_type: "CREDIT",
      transactionId: selectedTokenName.transactionId || "",
    };
    dispatch(updateTokenTransactionAsync(obj, selectedTokenName._id));
    setselectedTokenName({});
    creditModalClose();
  };

  // CREDIT: decline payment (mark as FAILED) with optional reason
  const handleCreditDecline = () => {
    setShowCreditReasonBox(true);
  };

  const handleCreditDeclineSubmit = () => {
    const obj = {
      status: "FAILED",
      decline_reason: creditDeclineReason,
      user_id: selectedTokenName.user_id,
      amount: selectedTokenName.amount,
      transaction_type: "CREDIT",
      transactionId: selectedTokenName.transactionId || "",
    };
    dispatch(updateTokenTransactionAsync(obj, selectedTokenName._id));
    setselectedTokenName({});
    creditModalClose();
  };

  //call delete email api and close delete model
  // const onDeactiveClick = () => {
  //   dispatch(deleteVirtualTokenAsync(selectedVirtualTokenName._id));
  //   setselectedTokenName({});
  //   deleteClose();
  // };

  //change status of virtual token and call update virtual token api
  // const handleToggle = (isActive, virtualTokenId) => {
  //   const values = {
  //     id: virtualTokenId,
  //     isActive: isActive === true ? false : true,
  //   };
  //   dispatch(updateVirtualTokenAsync(values));
  // };

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>User Name</th>
                  <th>Transaction ID</th>
                  <th>Bet ID</th>
                  <th>Credit/Debit</th>
                  <th>Transaction Type</th>
                  <th>Token</th>
                  <th>Total Tokens</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Approved By Admin</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {transactionList.data &&
                transactionList.data.transactionList.length ? (
                  transactionList.data.transactionList.map(
                    (transactionLists, index) => (
                      <tr key={index}>
                        <td>
                          <span className="f-w-500">
                            {skip * limit + (index + 1)}
                          </span>
                        </td>
                        <td>
                          <span>{transactionLists.userName}</span>
                        </td>
                        <td
                          style={{
                            wordBreak: "break-word",
                            maxWidth: "150px",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {transactionLists.transactionId}
                        </td>
                        <td>
                          <a
                            style={{ color: "#fff" }}
                            href={`/bet-management/bet-result-details/${transactionLists.bet_id}`}
                            target="_blank"
                          >
                            {transactionLists.bet_id}
                          </a>
                        </td>
                        <td>
                          <span>{transactionLists.transaction_type}</span>
                        </td>
                        <td>

                        {
                        !transactionLists.isCancelMatch && !transactionLists.isVoidMatch
                        ? transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE" &&
                        transactionLists.description === "DEPOSITED_BY_ADMIN"
                        ? "Deposited By Admin"
                        : transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE" &&
                        transactionLists.description?.startsWith("REFERRAL_BONUS")
                        ? "Referral Bonus"
                        : transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE" &&
                        transactionLists.description?.startsWith("REFERRAL_SIGNUP_BONUS")
                        ? "Signup Bonus"
                        : transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE" &&
                        transactionLists.description?.startsWith("PROMO_CODE_APPLIED")
                        ? "Deposit By Promo Code"
                        : transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE"
                        ? "Deposit"
                        : transactionLists.transaction_type === "DEBIT" &&
                        transactionLists.balance_type === "WITHDRAWABLE" &&
                        transactionLists.withdrawal_approved === false
                        ? "Withdrawal Requested"
                        : transactionLists.transaction_type === "DEBIT" &&
                        transactionLists.balance_type === "WITHDRAWABLE" &&
                        transactionLists.withdrawal_approved === true
                        ? "Withdrawal Success"
                        : transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "WITHDRAWABLE" &&
                        transactionLists.is_decline === true
                        ? "Withdrawal Declined"
                        : transactionLists.transaction_type === "CREDIT" &&
                        transactionLists.balance_type === "WITHDRAWABLE"
                        ? "Won Bet"
                        : transactionLists.transaction_type === "DEBIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE"
                        ? "Created/Joined Bet"
                        : transactionLists.transaction_type === "DEBIT" &&
                        transactionLists.balance_type === "WITHDRAWABLE"
                        ? "Withdrawal"
                        : ""
                        : transactionLists.isCancelMatch
                        ? transactionLists.transaction_type === "DEBIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE"
                        ? "Created/Joined Bet"
                        : "Cancelled Bet"
                        : transactionLists.isVoidMatch
                        ? transactionLists.transaction_type === "DEBIT" &&
                        transactionLists.balance_type === "NON_WITHDRAWABLE"
                        ? "Created/Joined Bet"
                        : "Voided Bet"
                        : ""
                        }

                         
                        </td>
                        <td>{transactionLists.amount}</td>
                        <td>{transactionLists.total_token}</td>

                        <td>
                          <button
                          style={{ cursor: "default" }} 
                            value={transactionLists && transactionLists.status}
                            className={`pmnt_btn ${
                              transactionLists &&
                              transactionLists.status === "SUCCESS"
                                ? "label label-lg label-light-success label-inline"
                                : transactionLists.status === "PENDING"
                                ? "label label-lg label-light-warning label-inline"
                                : "label label-lg label-light-danger label-inline"
                            }`}
                            // onClick={() => {
                            //   if (
                            //     transactionLists.balance_type === "WITHDRAWABLE" &&
                            //     transactionLists.transaction_type === "DEBIT" &&
                            //     transactionLists.status === "PENDING" &&
                            //     !transactionLists.withdrawal_approved &&
                            //     !transactionLists.is_decline
                            //   ) {
                            //     onApprovedClick(transactionLists);
                            //   } else if (
                            //     transactionLists.transaction_type === "CREDIT" 
                            //   ) {
                            //     onCreditApprovedClick(transactionLists);
                            //   }
                            // }}
                          >
                            {transactionLists &&
                            transactionLists.status === "SUCCESS"
                              ? "SUCCESS"
                              : transactionLists.status === "PENDING"
                              ? "PENDING"
                              : "FAILED"}
                          </button>
                        </td>
                        <td>
                          {transactionLists?.createdAt
                            ? moment(transactionLists.createdAt).format(
                                "MMM Do YYYY, h:mm:ss a"
                              )
                            : "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {transactionLists.balance_type === "WITHDRAWABLE" &&
                          transactionLists.transaction_type === "DEBIT" ? (
                            <button
                              value={
                                transactionLists &&
                                transactionLists.withdrawal_approved
                              }
                              className={`pmnt_btn ${
                                transactionLists
                                  ? transactionLists.withdrawal_approved ===
                                      false &&
                                    transactionLists.is_decline === false
                                    ? "label label-lg label-light-warning label-inline"
                                    : transactionLists.withdrawal_approved ===
                                      true
                                    ? "label label-lg label-light-success label-inline"
                                    : transactionLists.is_decline === true
                                    ? "label label-lg label-light-danger label-inline" // Added red color for decline
                                    : ""
                                  : ""
                              }`}
                              style={
                                transactionLists &&
                                (transactionLists.withdrawal_approved === true ||
                                  transactionLists.is_decline === true)
                                  ? { cursor: "default" }
                                  : {}
                              }
                              onClick={() => {
                                if (
                                  !transactionLists.withdrawal_approved &&
                                  !transactionLists.is_decline
                                ) {
                                  onApprovedClick(transactionLists);
                                }
                              }}
                            >
                              {transactionLists &&
                              transactionLists.withdrawal_approved === false &&
                              transactionLists.is_decline === false
                                ? "Pending"
                                : transactionLists.withdrawal_approved === true
                                ? "Approved"
                                : transactionLists.is_decline === true
                                ? "Declined"
                                : "-"}
                            </button>
                          ) : transactionLists.balance_type === "NON_WITHDRAWABLE" &&
                            transactionLists.transaction_type === "CREDIT" ? (
                            <button
                              value={transactionLists && transactionLists.status}
                              className={`pmnt_btn ${
                                transactionLists
                                  ? transactionLists.status === "PENDING"
                                    ? "label label-lg label-light-warning label-inline"
                                    : transactionLists.status === "SUCCESS"
                                    ? "label label-lg label-light-success label-inline"
                                    : transactionLists.status === "FAILED"
                                    ? "label label-lg label-light-danger label-inline"
                                    : ""
                                  : ""
                              }`}
                              style={
                                transactionLists &&
                                (transactionLists.status === "SUCCESS" ||
                                  transactionLists.status === "FAILED")
                                  ? { cursor: "default" }
                                  : {}
                              }
                              onClick={() => {
                                if (transactionLists.status === "PENDING") {
                                  onCreditApprovedClick(transactionLists);
                                }
                              }}
                            >
                              {transactionLists &&
                              transactionLists.status === "PENDING"
                                ? "Pending"
                                : transactionLists.status === "SUCCESS"
                                ? "Approved"
                                : transactionLists.status === "FAILED"
                                ? "Declined"
                                : "-"}
                            </button>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          <a
                            title="View"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                            // onClick={() => onEditClick(transactionLists)}
                            href={`/token-transaction/token-transaction-details/${transactionLists?._id}`}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/custom/eye.svg"
                                )}
                              />
                            </span>
                          </a>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={12} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan={12} className="text-center">
                      <div className="basic-verification-loader text-center">
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
            <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
              Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
              {transactionList?.data?.count} Records
            </div>
            <div className="col-md-8 text-left mb-5 aspgntn">
              <BasicPagination
                totalRecords={transactionList?.data?.count}
                limit={limit}
                batch={skip + 1}
                onBatchChange={onPageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={ApproveModal}
        onHide={deleteClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure you want to Approve or Decline transaction?
            </p>

            {showTextBox == true ? (
              <input
                placeholder=" Add reason for decline"
                type="text"
                className={`form-control full-text-box  pl-3`}
                name="decline_reason"
                onChange={(e) => {
                  setReasonDecline(e.target.value);
                }}
              />
            ) : null}

            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={deleteClose}
                >
                  Close
                </button>
              </div>
              {showTextBox == false ? (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button
                    className="btn_new btn-sm"
                    type="button"
                    onClick={handleToggle}
                  >
                    Approve it
                  </button>
                </div>
              ) : null}
              {showTextBox == false ? (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button
                    className="btn_new btn-sm"
                    type="button"
                    onClick={handleDiclineToggle}
                  >
                    Decline it
                  </button>
                </div>
              ) : (
                reasonDecline !== "" && (
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button
                      className="btn_new btn-sm"
                      type="button"
                      onClick={handleDiclineSubmit}
                    >
                      Submit
                    </button>
                  </div>
                )
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/* CREDIT Approve/Decline Modal */}
      <Modal
        show={CreditApproveModal}
        onHide={creditModalClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure you want to mark this payment as APPROVED or DECLINED?
            </p>

            {showCreditReasonBox === true ? (
              <input
                placeholder="Add reason for decline"
                type="text"
                className={`form-control full-text-box  pl-3`}
                name="credit_decline_reason"
                onChange={(e) => {
                  setCreditDeclineReason(e.target.value);
                }}
              />
            ) : null}

            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button className="btn_new btn-sm" type="button" onClick={creditModalClose}>
                  Close
                </button>
              </div>
              {showCreditReasonBox === false ? (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button className="btn_new btn-sm" type="button" onClick={handleCreditApprove}>
                    APPROVED
                  </button>
                </div>
              ) : null}
              {showCreditReasonBox === false ? (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button className="btn_new btn-sm" type="button" onClick={handleCreditDecline}>
                    DECLINED
                  </button>
                </div>
              ) : (
                <div className="form-group mr-5 mb-1 mt-2">
                  <button
                    className="btn_new btn-sm"
                    type="button"
                    disabled={creditDeclineReason.trim() === ""}
                    onClick={handleCreditDeclineSubmit}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TokenTransactionTable;
